import { getActionList } from "../types";
const initState = {
  data: [],
  isLoading: false,
  error: false,
};

export default function actionsReducer(state = initState, action = {}) {
  switch (action.type) {
    case getActionList.GET_LIST_OF_ACTIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case getActionList.GET_LIST_OF_ACTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };
    case getActionList.GET_LIST_OF_ACTIONS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
